export class HorizontalSlider {
	constructor() {
		this.wrappers = document.querySelectorAll('.impacts-wrapper');
		this.scrollAmount = 300;
		this.init();
	}

	init() {
		this.wrappers.forEach(wrapper => {
			const slider = wrapper.querySelector('.impacts');
			if (!slider) return;

			let isDown = false;
			let startX;
			let scrollLeft;

			slider.addEventListener('mousedown', (e) => {
				isDown = true;
				slider.style.cursor = 'grabbing';
				startX = e.pageX - slider.offsetLeft;
				scrollLeft = slider.scrollLeft;
			});

			slider.addEventListener('mouseleave', () => {
				isDown = false;
				slider.style.cursor = 'grab';
			});

			slider.addEventListener('mouseup', () => {
				isDown = false;
				slider.style.cursor = 'grab';
			});

			slider.addEventListener('mousemove', (e) => {
				if (!isDown) return;
				e.preventDefault();
				const x = e.pageX - slider.offsetLeft;
				const walk = (x - startX) * 2;
				slider.scrollLeft = scrollLeft - walk;
			});

			slider.style.cursor = 'grab';

			const arrowLeft = wrapper.querySelector('.arrow-left');
			const arrowRight = wrapper.querySelector('.arrow-right');

			const getScrollAmount = () => {
				const firstSlide = slider.querySelector('.impact');
				if (firstSlide) {
					const slideWidth = firstSlide.offsetWidth;
					const gap = parseInt(getComputedStyle(slider).gap) || 0;
					return slideWidth + gap;
				}
				return this.scrollAmount;
			};

			const updateArrowsState = () => {
				const isAtStart = slider.scrollLeft <= 0;
				const isAtEnd = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 1;

				if (arrowLeft) {
					arrowLeft.disabled = isAtStart;
					arrowLeft.style.opacity = isAtStart ? '0.3' : '1';
					arrowLeft.style.cursor = isAtStart ? 'not-allowed' : 'pointer';
				}

				if (arrowRight) {
					arrowRight.disabled = isAtEnd;
					arrowRight.style.opacity = isAtEnd ? '0.3' : '1';
					arrowRight.style.cursor = isAtEnd ? 'not-allowed' : 'pointer';
				}
			};

			updateArrowsState();

			slider.addEventListener('scroll', updateArrowsState);

			if (arrowLeft) {
				arrowLeft.addEventListener('click', () => {
					if (!arrowLeft.disabled) {
						slider.scrollBy({
							left: -getScrollAmount(),
							behavior: 'smooth'
						});
					}
				});
			}

			if (arrowRight) {
				arrowRight.addEventListener('click', () => {
					if (!arrowRight.disabled) {
						slider.scrollBy({
							left: getScrollAmount(),
							behavior: 'smooth'
						});
					}
				});
			}
		});
	}
}
